import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import filter from 'lodash/filter';

import PageHeader from '../../../shared/page-header/components/page-header';
import DefaultLoader from '../../../shared/default-loader/components/default-loader';
import RenderIf from '../../../shared/render-if/components/render-if';
import CampaignsTable from './campaigns-table';
import EmptyState from '../../../shared/empty-state/components/empty-state';
import CreateCampaignModal from './create-campaign-modal';
import ChooseCampaignModal from './choose-campaign-modal';
import MobileCampaignModal from './mobile-campaign-modal';
import campaignsConstants from '../constants/campaigns-constants';
import { getCampaigns, toggleChooseCampaignModal, toggleCreateCampaignModal } from '../actions/campaigns-actions';
import { getSites } from '../../link-creator/actions/link-creator-actions';
import registerConstants from '../../register/constants/register-constants';

class Campaigns extends Component {
  componentDidMount() {
    const { getCampaigns, sites, getSites } = this.props;

    getCampaigns();

    if (!sites) {
      getSites(true);
    }
  }

  openChooseCampaignModal() {
    const { toggleChooseCampaignModal } = this.props;

    toggleChooseCampaignModal(true);
  }

  getCampaignsTableColumns() {
    const { profile } = this.props;

    let hiddenLabels = [];
    if (profile && (profile.user_type === registerConstants.user_types.ib || profile.user_type === registerConstants.user_types.ifs_type)) {
      hiddenLabels = campaignsConstants.ib_ifs_user_hidden_labels;
    }

    const labels = filter(campaignsConstants.campaigns_table_head_items, a => hiddenLabels.indexOf(a.label) === -1);

    return labels;
  }

  render() {
    const { t } = this.context;
    const { campaigns, profile, httpInProgress, toggleCreateCampaignModal, toggleChooseCampaignModal, showCreateCampaignModal, showChooseCampaignModal, showMobileCampaignModal, sites } = this.props;
    const tableColumnLabels = this.getCampaignsTableColumns();

    return (
      <div className="campaigns-container">
        <RenderIf if={showChooseCampaignModal && profile}>
          <ChooseCampaignModal />
        </RenderIf>
        <RenderIf if={showCreateCampaignModal && profile}>
          <CreateCampaignModal />
        </RenderIf>
        <RenderIf if={showMobileCampaignModal && profile}>
          <MobileCampaignModal />
        </RenderIf>
        <div className="display-flex-vertical">
          <PageHeader title={'CAMPAIGNS.TITLE'} className="flex-pull-left" />
          <RenderIf if={!httpInProgress && campaigns && campaigns.length > 0}>
            <div className="transparent-btn flex-pull-right" onClick={() => toggleChooseCampaignModal(true)}>
              {t('CAMPAIGNS.CREATE_CAMPAIGN_BTN')}
            </div>
          </RenderIf>
        </div>
        <RenderIf if={!httpInProgress && campaigns && campaigns.length > 0}>
          <CampaignsTable sites={sites} tableOptions={tableColumnLabels} campaigns={campaigns} profile={profile} toggleCreateCampaignModal={toggleCreateCampaignModal} />
        </RenderIf>
        <RenderIf if={httpInProgress}>
          <div className="display-flex-center p-t-50 p-b-50">
            <DefaultLoader />
          </div>
        </RenderIf>
        <RenderIf if={!httpInProgress && campaigns && campaigns.length === 0}>
          <EmptyState title={'CAMPAIGNS.NO_CAMPAIGNS_MESSAGE'} actionButtonLabel={'CAMPAIGNS.CREATE_FIRST_CAMPAIGN'} callback={this.openChooseCampaignModal.bind(this)} />
        </RenderIf>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  campaigns: state.campaignsReducer.campaigns,
  profile: state.userProfileReducer.profile,
  httpInProgress: state.httpInProgressReducer.httpInProgress,
  showCreateCampaignModal: state.campaignsReducer.showCreateCampaignModal,
  showChooseCampaignModal: state.campaignsReducer.showChooseCampaignModal,
  showMobileCampaignModal: state.campaignsReducer.showMobileCampaignModal,
  sites: state.linkCreatorReducer.sites,
});

const mapDispatchToProps = dispatch => ({
  getCampaigns: () => {
    dispatch(getCampaigns());
  },
  toggleCreateCampaignModal: (show, link) => {
    dispatch(toggleCreateCampaignModal(show, link));
  },
  toggleChooseCampaignModal: show => {
    dispatch(toggleChooseCampaignModal(show));
  },
  getSites: (active, pageCode) => {
    dispatch(getSites(active, pageCode));
  },
});

Campaigns.contextTypes = {
  t: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(Campaigns);



// WEBPACK FOOTER //
// ./src/app/main/campaigns/components/campaigns.js